export default __webpack_public_path__ + "assets/810152015b6ddeb8a2a276e90207c495.svg";